import type { EcommerceFormValues } from '../schema';
import type { UseFormReturn } from 'react-hook-form';

// Kupujący to zwykle ta sama osoba co zgłaszający – uzupełniamy dane do
// zamówienia z danych kontaktowych, ale nigdy nie nadpisujemy tego, co user
// już wpisał.
const BILLING_AUTOFILL = [
  ['billing_first_name', 'first_name'],
  ['billing_last_name', 'last_name'],
  ['billing_phone', 'phone'],
  ['billing_email', 'email'],
] as const;

type BillingAutofillForm = Pick<
  UseFormReturn<EcommerceFormValues>,
  'getValues' | 'setValue'
>;

const autofillBillingData = ({ getValues, setValue }: BillingAutofillForm) => {
  BILLING_AUTOFILL.forEach(([target, source]) => {
    const value = getValues(source);
    if (value && !getValues(target)) setValue(target, value);
  });
};

export default autofillBillingData;
